module.exports = __webpack_public_path__ + "img/全球企业.e2da97ee.png";